import { map } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { UserService } from '../../../../services/user/user.service';
import { Injector } from '@angular/core';
import { EducationalPathItemDTO } from '../../../../dto/educational-path/educational-path-item.dto';
import { ProfilePathItemDTO } from '../../../../dto/educational-path/profile-path-item.dto';
import { EducationalPathUserDTO } from '../../../../dto/educational-path/educational-path-user.dto';

// Extended interface to match the actual data structure
interface ExtendedEducationalPathItemDTO extends EducationalPathItemDTO {
    id: number;
    type: string;
    descriptions: any[];
    visibility: string;
    organizations_id: number;
    version_start_date: string;
    version_end_date: string | null;
    base_id: number | null;
    deleted: boolean;
    locked: boolean;
    status: string;
}

interface MaintenanceItem {
    id: number;
    name: string;
    completed: boolean;
}

export function profile_paths_organization(componentDataSourceService: ComponentDataSourceService & { injector: Injector }) {
    const userService = componentDataSourceService.injector.get(UserService);

    return {
        name: 'Organisation',
        description: 'Vedligeholdelsesmoduler fra din organisation',
        execute: () => {
            return userService.getEducationalPaths().pipe(
                map((paths: EducationalPathUserDTO[]) => {
                    // Get items from non-BRS paths and any items with negative IDs
                    const items = paths.flatMap(path => {
                        const allItems = [...path.maintenance, ...path.requirements].map(item => item as unknown as ExtendedEducationalPathItemDTO);
                        return allItems.filter(item => 
                            item.id < 0 || // Items with negative IDs (regardless of organization)
                            ((path.organizations_id !== 1 && path.organizations_id !== 0) && item.id >= 0) // Non-BRS organizations with positive IDs
                        );
                    });

                    return items.map((item): ProfilePathItemDTO => {
                        return {
                            name: item.name,
                            subtypes: '',
                            participation_status: item.completed ? 'Gennemført' : 'Ikke gennemført',
                            type: item.id === 0 ? 'Selvvalgt' : 'Fastsat',
                            module_name: item.name,
                            item_id: item.id,
                            completed: item.completed
                        };
                    });
                })
            );
        },
        settings: {
            columns: [
                { 
                    key: 'name', 
                    header: 'Modul', 
                    type: 'text-with-subtitle',
                    subtitle: 'subtypes'
                },
                { key: 'participation_status', header: 'Status', type: 'text' },
                { key: 'type', header: 'Type', type: 'text' },
                {
                    key: 'module_name',
                    header: '',
                    type: 'button',
                    buttonText: 'Find tilmelding',
                    buttonColor: 'primary',
                    variant: 'raised',
                    alignment: 'right',
                    action: (row: any) => {
                        const searchParams = new URLSearchParams({
                            search: row.module_name,
                            type: 'module'
                        });
                        window.location.href = `/events?${searchParams.toString()}`;
                    }
                }
            ],
            pageable: false,
            sortable: false,
            rowHover: true,
            defaultSortColumn: 'name',
            defaultSortDirection: 'asc'
        }
    };
} 